import React from 'react';
import { connect } from 'react-redux';
import i18n from '../../../i18n/i18n';
import { Fab, MenuItem, Menu } from '@material-ui/core';
import ViewMachines from './ViewMachines'
import ViewMachinesGroup from './ViewMachinesGroup';
import ViewMachinesSubgroup from './ViewMachinesSubgroup';
import { toast } from 'react-toastify';
import { Delete } from "../../../utils/Delete";
import { deleteMachine, setInitialState } from '../../../actions/resources/MachinesActions';

const options = [
    i18n.t('Machines'),
    i18n.t('Machines Group'),
    i18n.t('Machines Subgroup')
]
export class MachinesMainComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            add: false,
            edit: false,
            showFilters: false,
            delete: false,
            anchorEl: null,
            selectedIndex: 0,
            selection: [],
            name: ''
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.deleted === true) {
            this.setState({
                selection: [],
                name: '',
            })
        }
        if (nextProps.machinesPostingSuccess == true || nextProps.machinesGroupsPostingSuccess == true || nextProps.machinesSubgroupsPostingSuccess == true) {
            this.setState({
                selection: [],
                name: '',
            })
        }
        if (nextProps.deleteMachineFailed === true) {
            toast.error(i18n.t('This item can not be deleted!'), {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                draggablePercent: 80
            });
            this.props.setInitialState('deleteMachineFailed')
        }
    }
    getUser() {
        let user = localStorage.getItem('user');
        let userObject = JSON.parse(user);
        !user && window.location.replace(window.location.origin);
        return userObject;
    }

    handleClick = () => {
        if (this.state.edit == true && this.state.add == false) {
            this.setState({ edit: false })
        }
        this.setState({ add: !this.state.add }, () => {
            if (this.state.add == true && this.state.edit == false) {
                this.setState({
                    selection: [],
                    name: '',
                })
            };
        });
    };


    onSearchClick() {
        this.setState({ showFilters: !this.state.showFilters });
    }

    handleClickAnchor = event => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleCloseAnchor = () => {
        this.setState({ anchorEl: null });
    };

    handleMenuItemClick = (event, index) => {
        this.setState({ selectedIndex: index, anchorEl: null, selection: [], name: '' });
    };

    handleSelection = (selection, name) => {
        this.setState({
            selection: selection,
            name: name
        })
    }

    onDeleteClick = () => {
        this.setState({ delete: !this.state.delete });
    }

    deleteItem = () => {
        this.props.deleteMachine(this.state.selection, this.state.name);
        this.setState({ delete: false })
    }

    onEditClick() {
        this.setState({ add: !this.state.add, edit: true });
    }


    render() {
        let user = this.getUser();
        let content;
        const { anchorEl } = this.state;
        content =
            <div className="table-header">
                {user && user.id_klijent_grupa === 8 &&
                    <Fab
                        onClick={this.handleClick}
                        color="secondary"
                        aria-label="add"
                        className="action-button"
                    >
                        <span className="icon-Plus headerIcon" />
                    </Fab>
                }
                <Fab
                    onClick={() => this.onSearchClick()}
                    color="secondary"
                    aria-label="add"
                    className="action-button"
                >
                    <span className="icon-search headerIcon" />
                </Fab>
                <Fab color="secondary" aria-label="add" className="action-button"
                    aria-owns={anchorEl ? 'simple-menu' : null}
                    aria-haspopup="true"
                    onClick={this.handleClickAnchor}>
                    <span className="icon-Vise headerIcon" />
                </Fab>
                <Menu
                    id="lock-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={this.handleCloseAnchor}
                >
                    {options.map((option, index) => (
                        <MenuItem
                            key={option}
                            selected={index === this.state.selectedIndex}
                            onClick={event => this.handleMenuItemClick(event, index)}
                        >
                            {i18n.t(option)}
                        </MenuItem>
                    ))}
                </Menu>
                {user && user.id_klijent_grupa === 8 && this.state.selection.length > 0 ?
                    <Fab
                        onClick={() => this.onDeleteClick()}
                        color="secondary"
                        aria-label="add"
                        className="action-button"
                    >
                        <span className="icon-Kanta headerIcon" />
                    </Fab>
                    : null
                }
                {user && user.id_klijent_grupa === 8 && this.state.selection.length === 1 ?
                    <Fab
                        onClick={() => this.onEditClick()}
                        color="secondary"
                        aria-label="edit"
                        className="action-button"
                    >
                        <span className="icon-Izmeni1 headerIcon" />
                    </Fab>
                    : null
                }
            </div>
        return (
            <div>
                {content}
                {this.state.selectedIndex === 0 && <ViewMachines setSelection={this.handleSelection} edit={this.state.edit} add={this.state.add} showFilters={this.state.showFilters}
                    handleClose={this.handleClick} />}
                {this.state.selectedIndex === 1 && <ViewMachinesGroup setSelection={this.handleSelection} edit={this.state.edit} add={this.state.add} showFilters={this.state.showFilters}
                    handleClose={this.handleClick} />}
                {this.state.selectedIndex === 2 && <ViewMachinesSubgroup setSelection={this.handleSelection} edit={this.state.edit} add={this.state.add} showFilters={this.state.showFilters}
                    handleClose={this.handleClick} />}
                {this.state.delete && <Delete delete={this.state.delete} handleClose={this.onDeleteClick} deleteItem={this.deleteItem} />}
            </div>
        )
    }


};

function mapStateToProps(state) {
    return {
        deleted: state.machinesReducer.deleted,
        deleteMachineFailed: state.machinesReducer.deleteMachineFailed,
        machinesSubgroupsPostingSuccess: state.machinesReducer.machinesSubgroupsPostingSuccess,
        machinesPostingSuccess: state.machinesReducer.machinesPostingSuccess,
        machinesGroupsPostingSuccess: state.machinesReducer.machinesGroupsPostingSuccess
    }
}

function mapDispatchToProps(dispatch) {
    return {
        deleteMachine: (selection, name) => dispatch(deleteMachine(selection, name)),
        setInitialState: (component) => dispatch(setInitialState(component)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MachinesMainComponent)